import {FsList} from '@/pages/components/audit/finance-statement/FsList';

export default {
  list: FsList,
};

export {FsCreateStepper} from '@/pages/components/audit/finance-statement/FsCreateStepper';
export {FsDetail} from '@/pages/components/audit/finance-statement/FsDetail';